import Settings from './settings';
import ReverseLookupZone from './reverse_lookup_zone';

const DNS = [
    Settings,
    ReverseLookupZone,
];

export default DNS;